import { useTheme } from '@emotion/react'

import { FrameIoMonoLogo, EarnestMonoLogo, RetoolMonoLogo } from '@segment/matcha/components/CompanyLogos/CompanyMono'

import { FrameIoLogo, EarnestLogo, RetoolLogo } from '@segment/matcha/components/CompanyLogos/Company'

const customerData = () => {
  const theme = useTheme()
  return [
    {
      company: `frame-io`,
      logo: <FrameIoMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <FrameIoLogo />,
      logoName: `FrameIo`,
    },
    {
      company: `earnest`,
      logo: <EarnestMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <EarnestLogo />,
      logoName: `Earnest`,
    },
    {
      company: `retool`,
      logo: <RetoolMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <RetoolLogo />,
      logoName: `Retool`,
    },
  ]
}

export { customerData }
